import { render } from "./AddTranscoderModal.vue?vue&type=template&id=bb3ab77a&scoped=true"
import script from "./AddTranscoderModal.vue?vue&type=script&lang=js"
export * from "./AddTranscoderModal.vue?vue&type=script&lang=js"

import "./AddTranscoderModal.vue?vue&type=style&index=0&id=bb3ab77a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb3ab77a"]])

export default __exports__